import { render, staticRenderFns } from "./WorkplaceList.vue?vue&type=template&id=477f9e8e&scoped=true&"
import script from "./WorkplaceList.vue?vue&type=script&lang=js&"
export * from "./WorkplaceList.vue?vue&type=script&lang=js&"
import style0 from "./WorkplaceList.vue?vue&type=style&index=0&id=477f9e8e&lang=scss&scoped=true&"
import style1 from "./WorkplaceList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477f9e8e",
  null
  
)

export default component.exports